/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalytics
 */

import { useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsLogic } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsLogic';
import type { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsConfig } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostDigitalSovereigntyAlmadarProposalSLAnalyticsRecord } from '@app/shared';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsViewProps {
  config?: Partial<AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsConfig>;
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView({ config: propsConfig }: AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostDigitalSovereigntyAlmadarProposalSLAnalyticsRecord'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostDigitalSovereigntyAlmadarProposalSL" trait="AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalytics">
      <UISlotComponent slot="system" pattern={slotWriter['system'] === 'INIT' ? "typography" : slotWriter['system'] === 'REPORTED' ? "typography" : slotWriter['system'] === 'REPORT_FAILED' ? "typography" : "clear"} sourceTrait="AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalytics">{slotWriter['system'] === 'INIT' ? (<Typography variant="caption" role="status" content="Reporting this visit…" />) : slotWriter['system'] === 'REPORTED' ? (<Typography variant="caption" role="status" content={(lastPayload?.sent) ? "Visit reported" : "Not reported here"} />) : slotWriter['system'] === 'REPORT_FAILED' ? (<Typography role="status" variant="caption" content={renderPatternValue(["Not reported: ", lastPayload?.error].join(''))} />) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView;
